<template>
  <div class="noPay">
    <div class="noPay__icon">
      <img
        src="../../../shared/assets/images/lockCheck.png"
        alt="icon"
        width="220px"
        height="220px"
      />
    </div>
    <div class="noPay__header">{{ $t('NoPayModal | title') }}</div>
    <div class="noPay__body rte">
      <div class="noPay__body-inner">
        {{ $t('NoPayModal | description') }}
      </div>
    </div>
    <div class="noPay__footer">
      <base-button type="cta" size="lg" @onClick="openTechSupportChat">
        {{ $t('NoPayModal | action') }}
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'

export default {
  name: 'NoPay',
  emits: ['close'],
  components: {
    BaseButton,
  },

  methods: {
    openTechSupportChat() {
      window.emcd.AnalyticsService.openDialogue()
      this.$emit('close')
    },
  },
}
</script>

<style scoped lang="scss">
.noPay {
  display: flex;
  color: var(--text-1);
  line-height: 1.2;
  word-break: break-word;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__icon {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 36px;
    margin-bottom: 50px;
    border-radius: 100%;
  }

  &__header {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
    text-align: center;
    font-weight: 700;
    font-size: 1.725rem; // 28px
    width: 100%;
    line-height: 1;
  }

  &__body {
    font-size: 16px;
    line-height: 24px;
  }

  .rte {
    line-height: 1.5;
    font-weight: 500;
    color: var(--text-2);
    text-align: center;
    margin-bottom: 40px;
  }
}

.base-loading {
  height: 54px;
}
</style>
